import React from 'react'

import { CartHeaderIconV2 } from '../../../assets/CartHeaderIconV2'
import { useCart } from '../../../sdk/cart'
import { useCartToggleButton } from '../../../sdk/cart/useCartToggleButton'
import Button from '../../ui/Button'
import './telesales-navbar.scss'

const SecondColumnHeader = () => {
  const { onClick } = useCartToggleButton()
  const { totalItems } = useCart()

  return (
    <div className="telesales-navbar__buttons justify-content-center">
      <div className="mobile-cart-use">
        <button
          aria-label="Cart button"
          className="button-modal-open-cart cart-toggle"
          onClick={onClick}
        >
          <span className="alignment">
            <CartHeaderIconV2 className="cart-toggle" />
            {totalItems > 0 && <div className="totalCart">{totalItems}</div>}
          </span>
        </button>
      </div>
      <div className="desk-cart-user">
        <div className="d-flex justify-content-around items-center ">
          <Button
            aria-label="Cart button"
            onClick={onClick}
            className="d-flex justify-content-around items-center my-cart"
          >
            <div className="containerIco cartIcon">
              <CartHeaderIconV2 className="cart-toggle" />
              {totalItems > 0 && <div className="totalCart">{totalItems}</div>}
            </div>
            <div className="my-cart">
              <span>
                Meu <br /> carrinho
              </span>
            </div>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SecondColumnHeader
